<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-file-powerpoint"
      texto-titulo="Historial de pedidos"
      :to-create-action="{name:'NuevoPedido'}"
      to-create-text="Nuevo pedido"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList url="/pedidos/historial" :fields="fields" :rowClick="ver" :toPesos="toPesos" :toDate="toDate"  ref="datatable"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import DataList from '@/components/layouts/DataList'
export default {
  name: "HistorialPedidos",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      fields: [
        {
          name: "cliente.nombre",
          label: "",
          type: "title",
          class: "",
          append: ' - '
        },
        {
          name: "total",
          label: "",
          type: "title",
          class: "text-success",
          prepend:'$',
        },
        {
          name: "created_at",
          label: "Fecha",
          type: "field",
          class: ""
        },
        {
          name: "estado",
          label: "Estado",
          type: "field",
          class: "text-capitalize text-alternate"
        },
        {
          name: "entrega",
          label: "Entrega",
          type: "field",
          class: "text-success",
          prepend: "$"
        }
      ],
      toPesos: ['total', 'entrega'],
      toDate:['created_at'],
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    ver(pedido){
      if(pedido.estado == 'pendiente'){
        this.$router.push('/pedidos/editar/'+pedido.id)
      }else{
        this.$router.push('/pedidos/ver/'+pedido.id)
      }
    }
  }
};
</script>